jQuery(document).foundation();

new WOW().init();

if(jQuery('.gallery-grid').length > 0 ) {
  var container = document.querySelector('#gallery');
  // initialize Masonry after all images have loaded
  imagesLoaded( container, function() {
    msnry = new Masonry(container, {
      itemSelector: '.gallery-item'
    });
  });
}

jQuery( document ).ready(function() {
    // Remove empty P tags created by WP inside of Accordion and Orbit
  jQuery('.accordion p:empty, .orbit p:empty').remove();

  // Adds Flex Video to YouTube and Vimeo Embeds
  // jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
  //   if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
  //     jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
  //   } else {
  //     jQuery(this).wrap("<div class='responsive-embed'/>");
  //   }
  // });

  jQuery('.gallery').each(function() { // the containers for all your galleries
      jQuery(this).magnificPopup({
          delegate: 'a.more', // the selector for gallery item
          type: 'image',
          gallery: {
            enabled:true
          },
          image: {
            titleSrc: function(item) {
              return item.el.data('mp-title');
            }
          }
      });
  });

  jQuery('#neighborhoodsNav').on('change', function(e) {
    var goTo = jQuery(this).val();
    window.location.href = goTo;
  });
  
});